"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/role.js"));
var _validate = require("@/utils/validate");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'roleEdit',
  props: {
    isCreate: {
      type: Number,
      required: 0
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      expandAll: false,
      loading: false,
      pram: {
        roleName: null,
        rules: '',
        status: null,
        id: null,
        merId: JSON.parse(_jsCookie.default.get('JavaMerInfo_copy')).id
      },
      menuExpand: false,
      menuNodeAll: false,
      menuOptions: [],
      menuCheckStrictly: true,
      currentNodeId: [],
      defaultProps: {
        children: 'childList',
        label: 'name',
        // 让 el-tree 认 item.disabled（checkDisabled() 锁定公共权限时用）
        disabled: 'disabled'
      },
      menuIds: []
    };
  },
  mounted: function mounted() {
    this.initEditData();
    this.getCacheMenu();
  },
  methods: {
    close: function close() {
      this.$emit('hideEditDialog');
    },
    initEditData: function initEditData() {
      var _this = this;
      if (this.isCreate !== 1) return;
      var _this$editData = this.editData,
        roleName = _this$editData.roleName,
        status = _this$editData.status,
        id = _this$editData.id,
        merId = _this$editData.merId;
      this.pram.roleName = roleName;
      this.pram.status = status;
      this.pram.id = id;
      this.pram.merId = JSON.parse(_jsCookie.default.get('JavaMerInfo_copy')).id;
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      roleApi.getInfo(id).then(function (res) {
        _this.menuOptions = res.menuList;
        _this.markHiddenMenus(_this.menuOptions);
        _this.checkDisabled(_this.menuOptions);
        loading.close();
        _this.getTreeId(res.menuList);
        _this.$nextTick(function () {
          _this.menuIds.forEach(function (i, n) {
            var node = _this.$refs.menu.getNode(i);
            if (node.isLeaf) {
              _this.$refs.menu.setChecked(node, true);
            }
          });
        });
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        var checkedKeys = _this2.getMenuAllCheckedKeys();
        _this2.pram.rules = checkedKeys.toString();
        // 基础权限被取消时先提醒一次。这几棵原先是置灰锁死的，改成可编辑后
        // 就得靠这道确认兜住误操作：取消了登录/上传/字典的权限点，挂这个角色的
        // 账号连后台都进不去。
        var missing = _this2.findMissingBaseMenus(checkedKeys);
        if (missing.length) {
          _this2.$confirm("\u4EE5\u4E0B\u57FA\u7840\u6743\u9650\u672A\u52FE\u9009\uFF1A".concat(missing.join('、'), "\u3002\u767B\u5F55\u3001\u4E0A\u4F20\u3001\u5B57\u5178\u7B49\u516C\u5171\u63A5\u53E3\u4F9D\u8D56\u5B83\u4EEC\uFF0C") + "\u53D6\u6D88\u540E\u4F7F\u7528\u8BE5\u89D2\u8272\u7684\u8D26\u53F7\u53EF\u80FD\u65E0\u6CD5\u6B63\u5E38\u4F7F\u7528\u540E\u53F0\uFF0C\u4E25\u91CD\u65F6\u767B\u5F55\u90FD\u4F1A\u5931\u8D25\u3002\u786E\u5B9A\u8FD9\u6837\u4FDD\u5B58\u5417\uFF1F", '基础权限缺失', {
            type: 'warning',
            confirmButtonText: '仍然保存',
            cancelButtonText: '返回修改'
          }).then(function () {
            return _this2.doSubmit();
          }).catch(function () {});
          return;
        }
        _this2.doSubmit();
      });
    }),
    doSubmit: function doSubmit() {
      if (this.isCreate === 0) {
        this.handlerSave();
      } else {
        this.handlerEdit();
      }
    },
    /**
     * 找出哪些基础权限没被勾上。
     *
     * 基础权限 = checkDisabled() 里那批固定 ID 的根节点，及其下面的叶子节点
     * （登录、上传、字典等公共接口的权限点）。只看叶子：父节点在保存时是靠
     * 半选态带上去的，单独判断会误报。
     */
    findMissingBaseMenus: function findMissingBaseMenus(checkedKeys) {
      var rootIds = this.getBaseMenuIds();
      if (!rootIds.length || !Array.isArray(this.menuOptions)) return [];
      var checked = new Set(checkedKeys);
      var missing = [];
      var _walkLeaves = function walkLeaves(nodes) {
        if (!Array.isArray(nodes)) return;
        nodes.forEach(function (node) {
          if (node.childList && node.childList.length) {
            _walkLeaves(node.childList);
          } else if (!checked.has(node.id)) {
            missing.push(node.name);
          }
        });
      };
      this.menuOptions.forEach(function (item) {
        if (rootIds.includes(item.id)) {
          if (item.childList && item.childList.length) _walkLeaves(item.childList);else if (!checked.has(item.id)) missing.push(item.name);
        }
      });
      return missing;
    },
    /** 基础权限的根菜单 ID，与 checkDisabled() 用的是同一批 */getBaseMenuIds: function getBaseMenuIds() {
      return [179, 180, 171];
    },
    handlerSave: function handlerSave() {
      var _this3 = this;
      this.loading = true;
      roleApi.addRole(this.pram).then(function (data) {
        _this3.$message.success('创建身份成功');
        _this3.$emit('hideEditDialog');
        _this3.loading = false;
      }).catch(function (res) {
        _this3.loading = false;
      });
    },
    handlerEdit: function handlerEdit() {
      var _this4 = this;
      this.loading = true;
      roleApi.updateRole(this.pram).then(function (data) {
        _this4.$message.success('更新身份成功');
        _this4.$emit('hideEditDialog');
        _this4.loading = false;
      }).catch(function (res) {
        _this4.loading = false;
      });
    },
    rulesSelect: function rulesSelect(selectKeys) {
      this.pram.rules = selectKeys;
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand: function handleCheckedTreeExpand(value, type) {
      // this.expandAll = true
      this.expandAll = this.menuExpand ? true : false;
      if (type == 'menu') {
        var treeList = this.menuOptions;
        for (var i = 0; i < treeList.length; i++) {
          this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll: function handleCheckedTreeNodeAll(value, type) {
      if (type == 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions : []);
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect: function handleCheckedTreeConnect(value, type) {
      if (type == 'menu') {
        this.menuCheckStrictly = value ? true : false;
      }
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys: function getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      var checkedKeys = this.$refs.menu.getCheckedKeys();
      // 半选中的菜单节点
      var halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    getCacheMenu: function getCacheMenu() {
      var _this5 = this;
      if (this.isCreate !== 0) return;
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      roleApi.menuCacheList().then(function (res) {
        _this5.menuOptions = res;
        _this5.markHiddenMenus(_this5.menuOptions);
        _this5.checkDisabled(_this5.menuOptions);
        loading.close();
      });
    },
    getTreeId: function getTreeId(datas) {
      for (var i in datas) {
        if (datas[i].checked) this.menuIds.push(datas[i].id);
        if (datas[i].childList) {
          this.getTreeId(datas[i].childList);
        }
      }
    },
    /**
     * 给已隐藏的菜单（isShow === false）加个「（已隐藏）」标注。
     *
     * is_show 在后端兼两职：既控制侧边栏显隐，也是接口权限开关
     * （UserDetailServiceImpl 组装 authorities 时会按它过滤），所以这类菜单
     * 当前勾上不会生效 —— 标注出来是让管理员心里有数，不是禁止他改：
     * 菜单以后重新放出来时，这些预先勾好的权限就直接生效了，
     * 所以【只标注、不置灰】，保持可编辑。
     *
     * 也不把它们从树里去掉：角色 rules 里可能已经存着这些 id，
     * 节点不存在 → 保存时提交的是剩下的可见项 → 那些勾选被静默丢掉。
     */
    markHiddenMenus: function markHiddenMenus(data) {
      var _this6 = this;
      if (!Array.isArray(data)) return;
      data.forEach(function (item) {
        if (item.isShow === false && item.name && item.name.indexOf('（已隐藏）') === -1) {
          item.name = item.name + '（已隐藏）';
        }
        if (item.childList) _this6.markHiddenMenus(item.childList);
      });
    },
    checkDisabled: function checkDisabled(data) {
      var _this7 = this;
      // 公共权限（登录/上传/字典这类基础设施）默认勾选。
      // 原先还会置灰锁死，防止误取消导致整个后台 403；现改为可编辑，
      // 需要时可以取消 —— 取消后该角色的登录/上传等接口会开始报 403，
      // 这是预期行为，由操作者自己负责。
      data.forEach(function (item) {
        if (item.id === 179 || item.id === 180 || item.id === 171) {
          item.childList.forEach(function (item1) {
            _this7.$nextTick(function () {
              var node = _this7.$refs.menu.getNode(item1.id);
              if (node.isLeaf) {
                _this7.$refs.menu.setChecked(node, true);
              }
            });
          });
        }
      });
    }
  }
};